export default __webpack_public_path__ + "static/media/imgFinishStamp.d96f7c0c.png";